module.exports = __webpack_public_path__ + "img/solution_7.d8cd8ed1.png";